var caseNotes = (function () {
  var deprecationPopupDismissed = false;
  function loadCaseNotesLanding() {
    let tryNewCaseNotes = button.build({
      text: 'Case Note Entry',
      style: 'secondary',
      type: 'contained',
        callback: async () => {
        $.session.isNewCaseNote = true;
        await CaseNotes.init();
        await CaseNotes.loadPage();
      },
    });    
    let overviewBtn = button.build({
      text: 'Review Notes',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        notesOverview.init();
      },
    });
    let editPhrasesBtn = button.build({
      text: 'Edit My Phrases',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        _DOM.ACTIONCENTER.setAttribute('data-UI', true);
        _DOM.setActiveModuleAttribute('casenotes2.0');
        _DOM.ACTIONCENTER.classList.add('actioncenterCaseNote');
        const cnPhrases = new CaseNotesPhrases(true);
        cnPhrases.renderTo(_DOM.ACTIONCENTER);
        await cnPhrases.InsertPhrases.fetchData();
        cnPhrases.InsertPhrases.populate();
        cnPhrases.InsertPhrases.show();
        cnPhrases.InsertPhrases.onPhraseSelect();

        // below code for when user click outside of popup , popup will closed and change module new caseload to old caseload
        function callbackToFixThisBadCode(event) {
          const dialog = document.getElementsByClassName('editPhrases');
          if (dialog != null && dialog[0] != undefined && dialog[0].className === event.target.className) {
            document.removeEventListener(callbackToFixThisBadCode);

            _DOM.ACTIONCENTER.removeAttribute('data-ui');
            _DOM.ACTIONCENTER.classList.remove('actioncenterCaseNote');
            setActiveModuleAttribute('casenotes');
            DOM.clearActionCenter();
            caseNotes.load();
          }
        }
        document.addEventListener('click', callbackToFixThisBadCode);
      },
    });

    var btnWrap = document.createElement('div');
    btnWrap.classList.add('landingBtnWrap');
    btnWrap.appendChild(tryNewCaseNotes);    
    btnWrap.appendChild(overviewBtn);
    btnWrap.appendChild(editPhrasesBtn);
    DOM.ACTIONCENTER.appendChild(btnWrap);

    setTimeout(() => {
      showDeprecationPopup();
    }, 300);
  }

  function showDeprecationPopup() {
    // Check cached value
    if (deprecationPopupDismissed) {
      return;
    }

    if (!$.session.CaseNotesUpdate) {
      return;
    }

    let messageText;
    if ($.session.applicationName === 'Gatekeeper') {
      messageText =
        'Please note that the NEW NOTE and NEW SSA NOTE buttons on this page will be removed in our next release. Until then, we encourage you to familiarize yourself with the NEW! CASE NOTE ENTRY button on this same page.';
    } else {
      messageText =
        'Please note that the NEW NOTE button on this page will be removed in our next release. Until then, we encourage you to familiarize yourself with the NEW! CASE NOTE ENTRY button on this same page.';
    }

    const confirmPopup = POPUP.build({
      header: 'ATTENTION!',
      hideX: true,
    });

    const remindLaterBtn = button.build({
      text: 'REMIND ME LATER',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        POPUP.hide(confirmPopup);
      },
    });

    const dontTellAgainBtn = button.build({
      text: "DON'T TELL ME AGAIN",
      style: 'secondary',
      type: 'contained',
      callback: () => {
        deprecationPopupDismissed = true;
        caseNotesAjax.setDeprecationPopupDismissed('Y', function (result) {});
        POPUP.hide(confirmPopup);
      },
    });

    const message = document.createElement('p');
    message.innerText = messageText;
    message.style.cssText = 'text-align: center; margin: 20px 0; line-height: 1.4;';

    var popupbtnWrap = document.createElement('div');
    popupbtnWrap.classList.add('btnWrap');
    popupbtnWrap.appendChild(remindLaterBtn);
    popupbtnWrap.appendChild(dontTellAgainBtn);

    confirmPopup.appendChild(message);
    confirmPopup.appendChild(popupbtnWrap);

    setTimeout(() => {
      const headerElement = confirmPopup.querySelector('h2, .popup-header, [class*="header"]');
      if (headerElement) {
        headerElement.style.cssText = 'text-align: center !important; width: 100%;';
      }
    }, 10);

    remindLaterBtn.focus();
    POPUP.show(confirmPopup);
  }

  function init() {
    _DOM.setActiveModuleAttribute('casenotes');
    _DOM.ACTIONCENTER.setAttribute('data-UI', false);
    DOM.clearActionCenter();
    //PERMISSION// caseNotesUpdate === false means they have view only permisison
    //Can't create new notes or update/delete notes. -- Skip the landing, and just load the overview page
    if (!$.session.CaseNotesUpdate) {
      notesOverview.init();
      return;
    }

    caseNotesAjax.getDeprecationPopupDismissed(async function (result) {
      deprecationPopupDismissed = result.getDeprecationPopupResult === 'Y';
      //await CaseNotes.init();
      loadCaseNotesLanding();
    });
  }

  return {
    load: init,
  };
})();
